export const lookupOtherText = (target: string) => {
  let res = ''
  if (!!target && target?.indexOf('Other<') !== -1) {
    res = target.substring(target.indexOf('Other<') + 6, target.indexOf('>,', target.indexOf('Others<')))
  }
  return res
}
